import type { ReactNode } from "react";
import closeSvg from "../assets/icon-close.svg";

interface ModalProps {
  open: boolean;
  title: string;
  onClose: () => void;
  children: ReactNode;
}

export function Modal({ open, title, onClose, children }: ModalProps) {
  if (!open) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-title"
      className="fixed inset-0 z-50 flex items-center justify-center"
    >
      <div
        className="absolute inset-0 bg-overlay"
        onClick={onClose}
        onKeyDown={(e) => { if (e.key === "Escape") onClose(); }}
        role="button"
        tabIndex={-1}
        aria-label="Close dialog"
      />
      <div className="relative bg-bg-primary rounded-2xl p-4 w-[600px] flex flex-col gap-4">
        <div className="flex items-center justify-between">
          <h3 id="modal-title" className="text-xl font-semibold text-text-primary">{title}</h3>
          <button onClick={onClose} aria-label="Close">
            <img src={closeSvg} alt="" width={24} height={24} />
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}
